import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { PROFILE } from '../../constants/api';
import { application } from '../../services/application';

const INITIAL_STATE = {
  pending: false,
  error: null,
};

export const updatePersonalInformation = createAsyncThunk('profile/updatePersonalInformation', async (params) => {
  return application.call(PROFILE.UPDATE, params);
});

export const setPhone = createAsyncThunk('profile/setPhone', async (params) => {
  return application.call(PROFILE.SET_PHONE, params);
});

export const setMFA = createAsyncThunk('profile/setMFA', async (params) => {
  return application.call(PROFILE.SET_MFA, params);
});

function onPending(state) {
  state.pending = true;
  state.error = null;
}

function onPendingDone(state) {
  state.pending = false;
}

function onRejected(state, action) {
  state.pending = false;
  state.error = action.error;
}

export const actions = {
  updatePersonalInformation,
  setPhone,
  setMFA,
};

export const profileReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(updatePersonalInformation.pending, onPending)
    .addCase(updatePersonalInformation.fulfilled, onPendingDone)
    .addCase(updatePersonalInformation.rejected, onRejected)
    .addCase(setPhone.pending, onPending)
    .addCase(setPhone.fulfilled, onPendingDone)
    .addCase(setPhone.rejected, onRejected)
    .addCase(setMFA.pending, onPending)
    .addCase(setMFA.fulfilled, onPendingDone)
    .addCase(setMFA.rejected, onRejected);
});